import { INITIAL_INCIDENTS_REQUEST, FETCH_INCIDENTS_SUCCESS } from "../../types/maintainers/incidents.type";

const initialState = {
	customers: [],
	incidents: [],
	last_page: 0,
	from: 0,
	to: 0,
	isFetching: false,
};

function maintainers_incidents(state = initialState, action) {
	switch (action.type) {
		case INITIAL_INCIDENTS_REQUEST:
			return {
				...state,
				isFetching: true,
			};

		case FETCH_INCIDENTS_SUCCESS:
			return {
				...state,
				isFetching: false,
				customers: action.payload.customers,
				incidents: action.payload.incidents,
				last_page: action.payload.last_page,
				from: action.payload.from,
				to: action.payload.to,
				quantity: action.payload.quantity,
			};
		default:
			return state;
	}
}

export default maintainers_incidents;
